import React, { useState, useRef } from 'react';
import onClickOutside from 'react-cool-onclickoutside';
import { FaAngleDown, FaAngleUp } from 'react-icons/fa';

function SelectInput2(props) {
  const [isListOpen, setIsListOpen] = useState(false);
  const ref = useRef();
  onClickOutside(ref, () => setIsListOpen(false));

  const header = "flex justify-between items-center text-white cursor-pointer ";
  const headerTitle = "uppercase w-32";
  const list = "absolute top-0 bg-cruise_darkblue pb-1 z-50";
  const baseItemClass = "text-white pl-4 pr-16 py-3 cursor-pointer";
  const listItem = "uppercase hover:bg-cruise_darkblue-secondary " + baseItemClass;
  const selectedItem = "bg-cruise_lightblue-secondary text-black hover:bg-cruise_orange " + baseItemClass;

  function getListClass() {
    if (props.directionUp) {
      return list + " rounded-t-lg";
    }
    return list + " rounded-b-lg";
  }
  function onItemSelected(item) {
    props.onItemSelected(props.id, item[props.valueKey]);
    if (!props.multiselect) {
      toggleList();
    }
  }
  function toggleList() {
    setIsListOpen(!isListOpen);
  }
  function getHeadertitle() {
    if (props.selectedItems && props.selectedItems.length > 0) {
      let selected = props.options
        .filter(x => props.selectedItems.includes(x.intId))
        .map(x => x.name)
        .join(", ");
      return selected;
    }

    return props.firstOption;
  }
  function renderHeader() {
    return <React.Fragment>
      <label htmlFor={props.id} className={props.labelClass}>{props.label}</label>
      <div id={props.id} className={header} onClick={toggleList}>
        <div className={headerTitle}>{getHeadertitle()}</div>
        <div className="">
          {isListOpen
            ? <FaAngleUp size={16} />
            : <FaAngleDown size={16} />
          }
        </div>
        {renderList()}
      </div>
    </React.Fragment>
  }
  function renderList() {
    if (isListOpen) {
      const styles = props.directionUp ? { bottom: 75 } : {};
      return <ul ref={ref} role="listbox" className={getListClass()} style={styles}>
        {props.options.map((item) =>
          <li role="option" key={item.id}
            className={props.selectedItems && props.selectedItems.includes(item.intId) ? selectedItem : listItem} 
            onClick={() => onItemSelected(item)}>
            {item[props.labelKey]}
          </li>
        )}
      </ul>
    }

    return null;
  }

  return (
    <div id={props.id} className={props.wrapperClass}>
      {renderHeader()}
    </div>
  );
}

{/*
    <div className={props.wrapperClass}>
      <label className={props.labelClass} htmlFor={props.id}>{props.label}</label>
      <div >
        <select id={props.id} className={props.selectPickerClass}
          onChange={(e) => { props.onChange(props.name, e) }}>
          <option value="0">{<span className={itemClass}>ANYWHERE</span>}</option>
          {props.options.map((opt) =>
            <option className={itemClass} value={opt.intId}><span className={itemClass}>{opt.name}</span></option>
          )}
        </select>
      </div>
    </div>
    */}

SelectInput2.defaultProps = {
  labelKey: "name",
  valueKey: "id",
  multiselect: false
}

export default SelectInput2;